export const SAVE_COLONY_NAME = 'SAVE_COLONY_SETTINGS'
export const SAVE_COLONY_NAME_OK = 'SAVE_COLONY_NAME_OK'
export const SAVE_COLONY_SHIELD = 'SAVE_COLONY_SHIELD'
export const SAVE_COLONY_SHIELD_OK = 'SAVE_COLONY_SHIELD_OK'
export const SAVE_COLONY_SETTINGS_ERROR = 'SAVE_COLONY_SETTINGS_ERROR'
export const SAVE_FEDERATION = 'SAVE_FEDERATION'
export const SAVE_FEDERATION_OK = 'SAVE_FEDERATION_OK'
export const SAVE_FEDERATION_ERROR = 'SAVE_FEDERATION_ERROR'
export const TUTORIAL_PLAYED = 'TUTORIAL_PLAYED'

export const saveColonyName = (settings) => {
  return { type: SAVE_COLONY_NAME, data: settings }
}
export const saveColonyNameOk = () => {
  return { type: SAVE_COLONY_NAME_OK }
}
export const saveColonyShield = (settings) => {
  return { type: SAVE_COLONY_SHIELD, data: settings }
}
export const saveColonyShieldOk = () => {
  return { type: SAVE_COLONY_SHIELD_OK }
}
export const saveColonySettingsError = (err) => {
  return { type: SAVE_COLONY_SETTINGS_ERROR, data: err }
}
export const saveSelectedFederation = (selectedFederation) => {
  return { type: SAVE_FEDERATION, data: selectedFederation }
}
export const saveSelectedFederationOk = () => {
  return { type: SAVE_FEDERATION_OK }
}
export const saveSelectedFederationError = (err) => {
  return { type: SAVE_FEDERATION_ERROR, data: err }
}
export const setTutorialPlayed = () => {
  return { type: TUTORIAL_PLAYED }
}
